//#region src/ReconnectError.ts
/**
* A typed error so that the client can catch it and handle it appropriately.
* Depending on how you connect the frontend to your backend, you will have to
* catch and serialize on your backend, then deserialize and re-throw on the
* client for correct reconnection behavior.
*/
var ReconnectError = class extends Error {
	constructor(message) {
		super(message ?? "Failed to connect to Tandem backend. Retry by refreshing the page.");
	}
};

//#endregion
export { ReconnectError };